import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import Funnel from './pages/Funnel';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import { analyticsService } from './services/analyticsService';

function AnalyticsTracker() {
  const location = useLocation();

  useEffect(() => {
    analyticsService.startSession(location.pathname);
    
    const handleUnload = () => {
      analyticsService.endSession();
    };

    window.addEventListener('beforeunload', handleUnload);
    return () => {
      handleUnload();
      window.removeEventListener('beforeunload', handleUnload);
    };
  }, [location]);

  return null;
}

function App() {
  return (
    <Router>
      <AnalyticsTracker />
      <div className="min-h-screen bg-stark-dark text-stark-light font-sans selection:bg-stark-lime selection:text-black">
        <Routes>
          <Route path="/" element={<><Navbar /><Home /></>} />
          <Route path="/start" element={<><Navbar /><Funnel /></>} />
          <Route path="/login" element={<Login />} />
          <Route path="/dashboard" element={<Dashboard />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;